module.exports = __webpack_public_path__ + "img/success.8c824f35.svg";